module.exports = __webpack_public_path__ + "img/merchpage_1.8788f5fa.png";